import { DateTime as DateTime$1 } from "../../../../../../../components/DateTime/index.js";
import { MAIL_VIEWS } from "../../../../../constants.js";
import { useMailStore } from "../../../../../stores/MailStore.js";
import { MessageDisplayNames } from "../../../../../components/MessageDisplayNames.js";
import "react";
import { Checkbox, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdPriorityHigh } from "react-icons/md";
import { HiFlag } from "react-icons/hi2";
//#region src/modules/Mail/screens/MailScreen/components/MailsMessageListDisplay/components/MessagesList.tsx
function MessagesList({ mailMessages, onClickMailMessage }) {
	const isSelectingMessages = useMailStore((state) => state.isSelectingMessages);
	const selectedMessagesIds = useMailStore((state) => state.selectedMessagesIds);
	const folder = useMailStore((state) => state.folder);
	const removeSelectedMessage = useMailStore((state) => state.removeSelectedMessage);
	const addSelectedMessage = useMailStore((state) => state.addSelectedMessage);
	return /* @__PURE__ */ jsx("ul", {
		className: classnames(isSelectingMessages ? "border-main" : "border-transparent", "relative rounded border"),
		children: mailMessages?.map((message) => /* @__PURE__ */ jsxs("li", {
			className: classnames("border-b-border first:border-t-border hover:bg-surface-strong hover:text-color-strong active:text-color-subtle flex max-w-full border-b border-l-4 transition first:border-t", { "bg-main-faded": selectedMessagesIds[message.id] }, folder === MAIL_VIEWS.INBOX && !message.userRead ? "border-l-info" : "border-l-transparent"),
			onClick: () => {
				if (isSelectingMessages) {
					if (selectedMessagesIds[message.id]) removeSelectedMessage(message.id);
					else addSelectedMessage(message.id);
				} else if (onClickMailMessage) onClickMailMessage(message.id);
			},
			children: [isSelectingMessages && /* @__PURE__ */ jsx("div", {
				className: "pl-sm pr-xs flex items-center",
				children: /* @__PURE__ */ jsx(Checkbox, {
					active: !!selectedMessagesIds[message.id],
					name: `is_selected_${message.id}`
				})
			}), /* @__PURE__ */ jsxs("div", {
				className: "p-sm group flex grow cursor-pointer flex-wrap-reverse justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "gap-x-xs flex flex-wrap items-baseline",
					children: [/* @__PURE__ */ jsxs("h3", {
						className: "text-color-subtle group-hover:text-color group-active:text-color-subtle text-sm font-bold transition",
						children: [/* @__PURE__ */ jsx(MessageDisplayNames, { message }), " "]
					}), /* @__PURE__ */ jsx("p", {
						className: classnames({ "text-color-subtle italic": !message.subject }, "text-color group-hover:text-color-strong group-active:text-color-subtle text-sm transition"),
						children: message.subject || "No subject"
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "space-x-xxs ml-auto flex items-center",
					children: [
						message.userFlagged && /* @__PURE__ */ jsx(Icon, {
							Icon: HiFlag,
							color: "caution",
							size: "xs"
						}),
						message.urgent && /* @__PURE__ */ jsx(Icon, {
							Icon: MdPriorityHigh,
							color: "critical",
							size: "xs"
						}),
						/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle group-hover:text-color group-active:text-color-subtle text-sm transition",
							children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: message.sentAt })
						})
					]
				})]
			})]
		}, message.id))
	});
}
//#endregion
export { MessagesList };

//# sourceMappingURL=MessagesList.js.map